// Please add Api Names in alphabetical order.
export enum ApiName {
	AddonFeatures = 'AddonFeatures',
	Addons = 'Addons',
	Annotations = 'Annotations',
	ARM = 'ARM',
	AssessmentBranch = 'AssessmentBranch',
	AssessmentBranchExperiments = 'AssessmentBranchExperiments',
	Assessments = 'Assessments',
	AzureMaps = 'AzureMaps',
	Blueprints = 'Blueprints',
	CaseManagement = 'CaseManagement',
	CustomActionsLoad = 'CustomActionsLoad',
	CustomActions = 'CustomActions',
	Dataview = 'Dataview',
	Entitlements = 'Entitlements',
	Environments = 'Environments',
	EventTracing = 'EventTracing',
	ExternalAssessments = 'ExternalAssessments',
	ExternalCall = 'ExternalCall',
	FQL = 'FQL',
	GDPR = 'GDPR',
	GlobalFunctions = 'GlobalFunctions',
	Header = 'Header',
	Hierarchy = 'Hierarchy',
	Lists = 'Lists',
	Metrics = 'Metrics',
	MsGraph = 'MsGraph',
	Notifications = 'Notifications',
	OptIn = 'OptIn',
	OverrideApplication = 'OverrideApplication',
	PageTemplate = 'PageTemplate',
	PageTemplateData = 'PageTemplateData',
	Permissions = 'Permissions',
	PowerBi = 'PowerBi',
	ProvisioningV2 = 'ProvisioningV2',
	Rbac = 'Rbac',
	RbacGql = 'RbacGql',
	Redirect = 'Redirect',
	RoutingRules = 'RoutingRules',
	Rules = 'Rules',
	Schema = 'Schema',
	Search = 'Search',
	SupportActions = 'SupportActions',
	Tenants = 'Tenants',
	UserPreferences = 'UserPreferences',
	Velocity = 'Velocity',
}
